const data = [
  {
    category: { url: '/en-GB/products/categories/soups', category: 'Soups' },
    item: 'Chicken Laksa Side Soup',
    url: '/en-GB/products/UK008242/chicken-laksa-side-soup',
    carbs: '17.4',
  },
  {
    category: { url: '/en-GB/products/categories/soups', category: 'Soups' },
    item: 'Chicken Laksa Soup',
    url: '/en-GB/products/UK008241/chicken-laksa-soup',
    carbs: '28.9',
  },
  {
    category: { url: '/en-GB/products/categories/soups', category: 'Soups' },
    item: 'Chicken, Broccoli & Brown Rice Soup',
    url: '/en-GB/products/UK005425/chicken-broccoli-and-brown-rice-soup',
    carbs: '8.5',
  },
  {
    category: { url: '/en-GB/products/categories/soups', category: 'Soups' },
    item: "EAT's. Chicken Pot Pie Side Soup",
    url: '/en-GB/products/UK008243/eats-chicken-pot-pie-side-soup',
    carbs: '10.6',
  },
  {
    category: { url: '/en-GB/products/categories/soups', category: 'Soups' },
    item: "EAT.'s Chicken Pot Pie Soup",
    url: '/en-GB/products/UK008050/eats-chicken-pot-pie-soup',
    carbs: '17.5',
  },
  {
    category: { url: '/en-GB/products/categories/soups', category: 'Soups' },
    item: 'Miso Soup',
    url: '/en-GB/products/UK001811/miso-soup',
    carbs: '4.2',
  },
  {
    category: { url: '/en-GB/products/categories/soups', category: 'Soups' },
    item: 'Pea & Mint Soup',
    url: '/en-GB/products/UK003102/pea-and-mint-soup',
    carbs: '18.2',
  },
  {
    category: { url: '/en-GB/products/categories/soups', category: 'Soups' },
    item: 'Pot Pie Top',
    url: '/en-GB/products/UK008072/pot-pie-top',
    carbs: '8.2',
  },
  {
    category: { url: '/en-GB/products/categories/soups', category: 'Soups' },
    item: "Pret's Chicken Katsu Curry Soup",
    url: '/en-GB/products/UK007762/prets-chicken-katsu-curry-soup',
    carbs: '20.4',
  },
  {
    category: { url: '/en-GB/products/categories/soups', category: 'Soups' },
    item: "Pret's Mushroom Risotto Soup",
    url: '/en-GB/products/UK007758/prets-mushroom-risotto-soup',
    carbs: '9.3',
  },
  {
    category: { url: '/en-GB/products/categories/soups', category: 'Soups' },
    item: 'Red Thai Veg Soup',
    url: '/en-GB/products/UK007764/red-thai-veg-soup',
    carbs: '17',
  },
  {
    category: { url: '/en-GB/products/categories/soups', category: 'Soups' },
    item: "Side Soup - Pret's Chicken Katsu Curry",
    url: '/en-GB/products/UK007761/side-soup-prets-chicken-katsu-curry',
    carbs: '12.2',
  },
  {
    category: { url: '/en-GB/products/categories/soups', category: 'Soups' },
    item: "Side Soup - Pret's Mushroom Risotto",
    url: '/en-GB/products/UK007757/side-soup-prets-mushroom-risotto',
    carbs: '5.5',
  },
  {
    category: { url: '/en-GB/products/categories/soups', category: 'Soups' },
    item: 'Side Soup - Red Thai Veg',
    url: '/en-GB/products/UK007763/side-soup-red-thai-veg',
    carbs: '10.1',
  },
  {
    category: { url: '/en-GB/products/categories/soups', category: 'Soups' },
    item: 'Side Soup -Chicken, Broccoli & Brown Rice',
    url: '/en-GB/products/UK006549/side-soup-chicken-broccoli-and-brown-rice',
    carbs: '5.1',
  },
  {
    category: { url: '/en-GB/products/categories/soups', category: 'Soups' },
    item: 'Side Soup -Pea & Mint ',
    url: '/en-GB/products/UK006225/side-soup-pea-and-mint',
    carbs: '10.8',
  },
  {
    category: { url: '/en-GB/products/categories/soups', category: 'Soups' },
    item: 'Side Soup -Souper Tomato ',
    url: '/en-GB/products/UK006550/side-soup-souper-tomato',
    carbs: '10.1',
  },
  {
    category: { url: '/en-GB/products/categories/soups', category: 'Soups' },
    item: 'Souper Tomato Soup',
    url: '/en-GB/products/UK006220/souper-tomato-soup',
    carbs: '17',
  },
  {
    category: { url: '/en-GB/products/categories/soups', category: 'Soups' },
    item: 'Stone Baked Losange Soup Baguette',
    url: '/en-GB/products/UK006425/stone-baked-losange-soup-baguette',
    carbs: '39',
  },
  {
    category: {
      url: '/en-GB/products/categories/organic-coffee',
      category: 'Organic Coffee',
    },
    item: 'Black Americano ',
    url: '/en-GB/products/UK006642/black-americano',
    carbs: '0',
  },
  {
    category: {
      url: '/en-GB/products/categories/organic-coffee',
      category: 'Organic Coffee',
    },
    item: 'Black Filter Coffee ',
    url: '/en-GB/products/UK001256/black-filter-coffee',
    carbs: '0',
  },
  {
    category: {
      url: '/en-GB/products/categories/organic-coffee',
      category: 'Organic Coffee',
    },
    item: 'Cappuccino',
    url: '/en-GB/products/UK006555/cappuccino',
    carbs: '8.8',
  },
  {
    category: {
      url: '/en-GB/products/categories/organic-coffee',
      category: 'Organic Coffee',
    },
    item: 'Caramel Syrup',
    url: '/en-GB/products/UK003991/caramel-syrup',
    carbs: '12.1',
  },
  {
    category: {
      url: '/en-GB/products/categories/organic-coffee',
      category: 'Organic Coffee',
    },
    item: 'Cold Brew without milk',
    url: '/en-GB/products/UK007400/cold-brew-without-milk',
    carbs: '0.5',
  },
  {
    category: {
      url: '/en-GB/products/categories/organic-coffee',
      category: 'Organic Coffee',
    },
    item: 'Espresso',
    url: '/en-GB/products/UK006643/espresso',
    carbs: '0',
  },
  {
    category: {
      url: '/en-GB/products/categories/organic-coffee',
      category: 'Organic Coffee',
    },
    item: 'Flat White',
    url: '/en-GB/products/UK006647/flat-white',
    carbs: '7.7',
  },
  {
    category: {
      url: '/en-GB/products/categories/organic-coffee',
      category: 'Organic Coffee',
    },
    item: 'Hazelnut Syrup ',
    url: '/en-GB/products/UK003990/hazelnut-syrup',
    carbs: '11.7',
  },
  {
    category: {
      url: '/en-GB/products/categories/organic-coffee',
      category: 'Organic Coffee',
    },
    item: 'Latte',
    url: '/en-GB/products/UK006780/latte',
    carbs: '11.3',
  },
  {
    category: {
      url: '/en-GB/products/categories/organic-coffee',
      category: 'Organic Coffee',
    },
    item: 'Macchiato ',
    url: '/en-GB/products/UK006712/macchiato',
    carbs: '0.5',
  },
  {
    category: {
      url: '/en-GB/products/categories/organic-coffee',
      category: 'Organic Coffee',
    },
    item: 'Mocha',
    url: '/en-GB/products/UK006553/mocha',
    carbs: '24.4',
  },
  {
    category: {
      url: '/en-GB/products/categories/organic-coffee',
      category: 'Organic Coffee',
    },
    item: 'Vanilla Syrup ',
    url: '/en-GB/products/UK003989/vanilla-syrup',
    carbs: '12',
  },
  {
    category: {
      url: '/en-GB/products/categories/organic-coffee',
      category: 'Organic Coffee',
    },
    item: 'White Americano',
    url: '/en-GB/products/UK006641/white-americano',
    carbs: '3.8',
  },
  {
    category: { url: '/en-GB/products/categories/salads', category: 'Salads' },
    item: '2oz Tamari & Ginger Dressing',
    url: '/en-GB/products/UK008035/2oz-tamari-and-ginger-dressing',
    carbs: '14.2',
  },
  {
    category: { url: '/en-GB/products/categories/salads', category: 'Salads' },
    item: "Chef's Italian Chicken Salad",
    url: '/en-GB/products/UK006282/chefs-italian-chicken-salad',
    carbs: '11.2',
  },
  {
    category: { url: '/en-GB/products/categories/salads', category: 'Salads' },
    item: 'Chipotle Chicken Burrito Bowl',
    url: '/en-GB/products/UK008220/chipotle-chicken-burrito-bowl',
    carbs: '50.9',
  },
  {
    category: { url: '/en-GB/products/categories/salads', category: 'Salads' },
    item: 'Chipotle Sweet Potato Salad Bowl',
    url: '/en-GB/products/UK008152/chipotle-sweet-potato-salad-bowl',
    carbs: '33.7',
  },
  {
    category: { url: '/en-GB/products/categories/salads', category: 'Salads' },
    item: 'Crayfish & Avocado No Bread',
    url: '/en-GB/products/UK001775/crayfish-and-avocado-no-bread',
    carbs: '4.2',
  },
  {
    category: { url: '/en-GB/products/categories/salads', category: 'Salads' },
    item: 'Egg & Spinach Protein Pot',
    url: '/en-GB/products/UK005381/egg-and-spinach-protein-pot',
    carbs: '2.4',
  },
  {
    category: { url: '/en-GB/products/categories/salads', category: 'Salads' },
    item: 'Falafel & Humous Rice Bowl',
    url: '/en-GB/products/UK008228/falafel-and-humous-rice-bowl',
    carbs: '52.3',
  },
  {
    category: { url: '/en-GB/products/categories/salads', category: 'Salads' },
    item: 'French Dressing - Large',
    url: '/en-GB/products/UK006021/french-dressing-large',
    carbs: '3.4',
  },
  {
    category: { url: '/en-GB/products/categories/salads', category: 'Salads' },
    item: 'French Dressing - Small',
    url: '/en-GB/products/UK006022/french-dressing-small',
    carbs: '1.9',
  },
  {
    category: { url: '/en-GB/products/categories/salads', category: 'Salads' },
    item: 'Humous & Falafel Mezze',
    url: '/en-GB/products/UK007925/humous-and-falafel-mezze',
    carbs: '48.7',
  },
  {
    category: { url: '/en-GB/products/categories/salads', category: 'Salads' },
    item: 'Salmon & Pickles Rice Bowl',
    url: '/en-GB/products/UK008222/salmon-and-pickles-rice-bowl',
    carbs: '52.2',
  },
  {
    category: { url: '/en-GB/products/categories/salads', category: 'Salads' },
    item: 'Salmon and Mango Salad Bowl',
    url: '/en-GB/products/UK008069/salmon-and-mango-salad-bowl',
    carbs: '11.9',
  },
  {
    category: { url: '/en-GB/products/categories/salads', category: 'Salads' },
    item: 'Smoked Salmon & Egg Protein Pot',
    url: '/en-GB/products/UK007084/smoked-salmon-and-egg-protein-pot',
    carbs: '1.6',
  },
  {
    category: { url: '/en-GB/products/categories/salads', category: 'Salads' },
    item: 'Tamari & Ginger Chicken Salad Bowl',
    url: '/en-GB/products/UK008149/tamari-and-ginger-chicken-salad-bowl',
    carbs: '19.2',
  },
  {
    category: { url: '/en-GB/products/categories/salads', category: 'Salads' },
    item: 'Tuna Nicoise Salad',
    url: '/en-GB/products/UK006483/tuna-nicoise-salad',
    carbs: '7.4',
  },
  {
    category: { url: '/en-GB/products/categories/sweet-treats', category: 'Sweet Treats' },
    item: 'Almond Butter Bites',
    url: '/en-GB/products/UK007205/almond-butter-bites',
    carbs: '8',
  },
  {
    category: { url: '/en-GB/products/categories/sweet-treats', category: 'Sweet Treats' },
    item: 'Banana Cake',
    url: '/en-GB/products/UK000821/banana-cake',
    carbs: '30',
  },
  {
    category: { url: '/en-GB/products/categories/sweet-treats', category: 'Sweet Treats' },
    item: 'Carrot Cake',
    url: '/en-GB/products/UK000880/carrot-cake',
    carbs: '37',
  },
  {
    category: { url: '/en-GB/products/categories/sweet-treats', category: 'Sweet Treats' },
    item: 'Choc Bar',
    url: '/en-GB/products/UK003339/choc-bar',
    carbs: '31.8',
  },
  {
    category: { url: '/en-GB/products/categories/sweet-treats', category: 'Sweet Treats' },
    item: 'Chocolate Brownie Bar',
    url: '/en-GB/products/UK004206/chocolate-brownie-bar',
    carbs: '28',
  },
  {
    category: { url: '/en-GB/products/categories/sweet-treats', category: 'Sweet Treats' },
    item: 'Chocolate Chunk Cookie',
    url: '/en-GB/products/UK004340/chocolate-chunk-cookie',
    carbs: '53.9',
  },
  {
    category: { url: '/en-GB/products/categories/sweet-treats', category: 'Sweet Treats' },
    item: 'Chocolate Praline Cookie',
    url: '/en-GB/products/UK006571/chocolate-praline-cookie',
    carbs: '43.4',
  },
  {
    category: { url: '/en-GB/products/categories/sweet-treats', category: 'Sweet Treats' },
    item: 'Dark Chocolate & Almond Butter Cookie',
    url: '/en-GB/products/UK006929/dark-chocolate-and-almond-butter-cookie',
    carbs: '50.9',
  },
  {
    category: { url: '/en-GB/products/categories/sweet-treats', category: 'Sweet Treats' },
    item: 'Dark Chocolate Corn Cakes',
    url: '/en-GB/products/UK005993/dark-chocolate-corn-cakes',
    carbs: '32.3',
  },
  {
    category: { url: '/en-GB/products/categories/sweet-treats', category: 'Sweet Treats' },
    item: 'Dark Chocolate with Sea Salt',
    url: '/en-GB/products/UK004976/dark-chocolate-with-sea-salt',
    carbs: '12',
  },
  {
    category: { url: '/en-GB/products/categories/sweet-treats', category: 'Sweet Treats' },
    item: 'Double Berry Muffin',
    url: '/en-GB/products/UK001755/double-berry-muffin',
    carbs: '53.4',
  },
  {
    category: { url: '/en-GB/products/categories/sweet-treats', category: 'Sweet Treats' },
    item: 'Fruit, Oat & Spelt Cookie',
    url: '/en-GB/products/UK006082/fruit-oat-and-spelt-cookie',
    carbs: '49.4',
  },
  {
    category: { url: '/en-GB/products/categories/sweet-treats', category: 'Sweet Treats' },
    item: 'Ginger Snap Biscuit',
    url: '/en-GB/products/UK007649/ginger-snap-biscuit',
    carbs: '40',
  },
  {
    category: { url: '/en-GB/products/categories/sweet-treats', category: 'Sweet Treats' },
    item: 'Gluten-Free Lemon Drizzle Cake',
    url: '/en-GB/products/UK007058/gluten-free-lemon-drizzle-cake',
    carbs: '34',
  },
  {
    category: { url: '/en-GB/products/categories/sweet-treats', category: 'Sweet Treats' },
    item: 'Love Bar',
    url: '/en-GB/products/UK001813/love-bar',
    carbs: '37.9',
  },
  {
    category: { url: '/en-GB/products/categories/sweet-treats', category: 'Sweet Treats' },
    item: 'Milk Chocolate Bar',
    url: '/en-GB/products/UK004448/milk-chocolate-bar',
    carbs: '12.2',
  },
  {
    category: { url: '/en-GB/products/categories/sweet-treats', category: 'Sweet Treats' },
    item: 'Pecan Slice',
    url: '/en-GB/products/UK005646/pecan-slice',
    carbs: '34.8',
  },
  {
    category: { url: '/en-GB/products/categories/sweet-treats', category: 'Sweet Treats' },
    item: 'Pret Bar',
    url: '/en-GB/products/UK001653/pret-bar',
    carbs: '34.5',
  },
  {
    category: { url: '/en-GB/products/categories/sweet-treats', category: 'Sweet Treats' },
    item: "Pret's Bakewell Slice",
    url: '/en-GB/products/UK005645/prets-bakewell-slice',
    carbs: '45.9',
  },
  {
    category: { url: '/en-GB/products/categories/sweet-treats', category: 'Sweet Treats' },
    item: "Pret's Gingerbread Biscuit",
    url: '/en-GB/products/UK004165/prets-gingerbread-biscuit',
    carbs: '33.2',
  },
  {
    category: { url: '/en-GB/products/categories/sweet-treats', category: 'Sweet Treats' },
    item: "Pret's Nut Bar",
    url: '/en-GB/products/UK007503/prets-nut-bar',
    carbs: '15.4',
  },
  {
    category: { url: '/en-GB/products/categories/sweet-treats', category: 'Sweet Treats' },
    item: "Pret's Shortbread",
    url: '/en-GB/products/UK006312/prets-shortbread',
    carbs: '40.3',
  },
  {
    category: { url: '/en-GB/products/categories/sweet-treats', category: 'Sweet Treats' },
    item: 'Pret’s Pecan & Caramel Cookie',
    url: '/en-GB/products/UK007650/prets-pecan-and-caramel-cookie',
    carbs: '53.5',
  },
  {
    category: { url: '/en-GB/products/categories/sweet-treats', category: 'Sweet Treats' },
    item: 'Victoria Sponge',
    url: '/en-GB/products/UK005769/victoria-sponge',
    carbs: '58',
  },
  {
    category: { url: '/en-GB/products/categories/platters', category: 'Platters' },
    item: 'All Time Classics Platter',
    url: '/en-GB/products/UK008079/all-time-classics-platter',
  },
  {
    category: { url: '/en-GB/products/categories/platters', category: 'Platters' },
    item: 'Baguette Selection Platter',
    url: '/en-GB/products/UK008081/baguette-selection-platter',
  },
  {
    category: { url: '/en-GB/products/categories/platters', category: 'Platters' },
    item: 'The Best of Pret Selection Platter',
    url: '/en-GB/products/UK008080/the-best-of-pret-selection-platter',
  },
  {
    category: { url: '/en-GB/products/categories/baguettes', category: 'Baguettes' },
    item: 'Avo, Olives & Toms',
    url: '/en-GB/products/UK006207/avo-olives-and-toms',
    carbs: '55.4',
  },
  {
    category: { url: '/en-GB/products/categories/baguettes', category: 'Baguettes' },
    item: 'Brie, Tomato & Basil',
    url: '/en-GB/products/UK001040/brie-tomato-and-basil',
    carbs: '60.9',
  },
  {
    category: { url: '/en-GB/products/categories/baguettes', category: 'Baguettes' },
    item: 'Chicken Caesar & Bacon',
    url: '/en-GB/products/UK006823/chicken-caesar-and-bacon',
    carbs: '53.8',
  },
  {
    category: { url: '/en-GB/products/categories/baguettes', category: 'Baguettes' },
    item: 'Chipotle Chicken',
    url: '/en-GB/products/UK007260/chipotle-chicken',
    carbs: '63.2',
  },
  {
    category: { url: '/en-GB/products/categories/baguettes', category: 'Baguettes' },
    item: 'Italian Prosciutto',
    url: '/en-GB/products/UK003546/italian-prosciutto',
    carbs: '55',
  },
  {
    category: { url: '/en-GB/products/categories/baguettes', category: 'Baguettes' },
    item: 'Jambon-Beurre',
    url: '/en-GB/products/UK005266/jambon-beurre',
    carbs: '41.1',
  },
  {
    category: { url: '/en-GB/products/categories/baguettes', category: 'Baguettes' },
    item: 'Pole & Line Caught Tuna Mayo & Cucumber',
    url: '/en-GB/products/UK000962/pole-and-line-caught-tuna-mayo-and-cucumber',
    carbs: '62.9',
  },
  {
    category: { url: '/en-GB/products/categories/baguettes', category: 'Baguettes' },
    item: 'Posh Cheddar & Pickle',
    url: '/en-GB/products/UK001921/posh-cheddar-and-pickle',
    carbs: '69.6',
  },
  {
    category: { url: '/en-GB/products/categories/baguettes', category: 'Baguettes' },
    item: 'Wiltshire-Cured Ham & Greve',
    url: '/en-GB/products/UK000682/wiltshire-cured-ham-and-greve',
    carbs: '59.5',
  },
  {
    category: { url: '/en-GB/products/categories/pret-snacks', category: 'Pret Snacks' },
    item: 'Chocolatey Coconut Bite',
    url: '/en-GB/products/UK006446/chocolatey-coconut-bite',
    carbs: '7.7',
  },
  {
    category: { url: '/en-GB/products/categories/pret-snacks', category: 'Pret Snacks' },
    item: 'Cranberries in Coats',
    url: '/en-GB/products/UK004735/cranberries-in-coats',
    carbs: '35.3',
  },
  {
    category: { url: '/en-GB/products/categories/pret-snacks', category: 'Pret Snacks' },
    item: 'Dark Chocolate Salted Almonds',
    url: '/en-GB/products/UK007204/dark-chocolate-salted-almonds',
    carbs: '12.9',
  },
  {
    category: { url: '/en-GB/products/categories/pret-snacks', category: 'Pret Snacks' },
    item: 'Easy Peasy Almond Squeezy',
    url: '/en-GB/products/UK007752/easy-peasy-almond-squeezy',
    carbs: '4',
  },
  {
    category: { url: '/en-GB/products/categories/pret-snacks', category: 'Pret Snacks' },
    item: 'Mature Cheddar & Red Onion Crisps',
    url: '/en-GB/products/UK003039/mature-cheddar-and-red-onion-crisps',
    carbs: '21.2',
  },
  {
    category: { url: '/en-GB/products/categories/pret-snacks', category: 'Pret Snacks' },
    item: 'Naked Nuts',
    url: '/en-GB/products/UK004737/naked-nuts',
    carbs: '4.4',
  },
  {
    category: { url: '/en-GB/products/categories/pret-snacks', category: 'Pret Snacks' },
    item: 'Nuts, Fruit & Chocolate',
    url: '/en-GB/products/UK006936/nuts-fruit-and-chocolate',
    carbs: '12.9',
  },
  {
    category: { url: '/en-GB/products/categories/pret-snacks', category: 'Pret Snacks' },
    item: 'Pret A Mango',
    url: '/en-GB/products/UK005296/pret-a-mango',
    carbs: '28.5',
  },
  {
    category: { url: '/en-GB/products/categories/pret-snacks', category: 'Pret Snacks' },
    item: 'Rock Salt Popcorn',
    url: '/en-GB/products/UK004019/rock-salt-popcorn',
    carbs: '15.5',
  },
  {
    category: { url: '/en-GB/products/categories/pret-snacks', category: 'Pret Snacks' },
    item: 'Sea Salt & Cider Vinegar Crisps',
    url: '/en-GB/products/UK003038/sea-salt-and-cider-vinegar-crisps',
    carbs: '22.2',
  },
  {
    category: { url: '/en-GB/products/categories/pret-snacks', category: 'Pret Snacks' },
    item: 'Sea Salt Crisps',
    url: '/en-GB/products/UK003037/sea-salt-crisps',
    carbs: '21.1',
  },
  {
    category: { url: '/en-GB/products/categories/pret-snacks', category: 'Pret Snacks' },
    item: 'Smoked Chipotle Crisps',
    url: '/en-GB/products/UK006813/smoked-chipotle-crisps',
    carbs: '20.8',
  },
  {
    category: { url: '/en-GB/products/categories/pret-snacks', category: 'Pret Snacks' },
    item: 'Sweet & Salt Popcorn',
    url: '/en-GB/products/UK004255/sweet-and-salt-popcorn',
    carbs: '16.4',
  },
  {
    category: { url: '/en-GB/products/categories/pret-snacks', category: 'Pret Snacks' },
    item: 'Vegetable Crisps',
    url: '/en-GB/products/UK005418/vegetable-crisps',
    carbs: '15.6',
  },
  {
    category: { url: '/en-GB/products/categories/wraps', category: 'Wraps' },
    item: 'Avocado & Herb Salad Wrap',
    url: '/en-GB/products/UK001501/avocado-and-herb-salad-wrap',
    carbs: '39.7',
  },
  {
    category: { url: '/en-GB/products/categories/wraps', category: 'Wraps' },
    item: 'Hoisin Duck Salad Wrap',
    url: '/en-GB/products/UK007579/hoisin-duck-salad-wrap',
    carbs: '46',
  },
  {
    category: { url: '/en-GB/products/categories/wraps', category: 'Wraps' },
    item: 'Humous & Chipotle Wrap',
    url: '/en-GB/products/UK007506/humous-and-chipotle-wrap',
    carbs: '51.4',
  },
  {
    category: { url: '/en-GB/products/categories/wraps', category: 'Wraps' },
    item: 'Vegan Chilli Wrap',
    url: '/en-GB/products/UK008007/vegan-chilli-wrap',
    carbs: '49',
  },
  {
    category: { url: '/en-GB/products/categories/sandwiches', category: 'Sandwiches' },
    item: 'Chicken, Avocado & Basil',
    url: '/en-GB/products/UK000809/chicken-avocado-and-basil',
    carbs: '41.3',
  },
  {
    category: { url: '/en-GB/products/categories/sandwiches', category: 'Sandwiches' },
    item: 'Classic Super Club',
    url: '/en-GB/products/UK006827/classic-super-club',
    carbs: '41.6',
  },
  {
    category: { url: '/en-GB/products/categories/sandwiches', category: 'Sandwiches' },
    item: 'Free-Range Egg Mayo',
    url: '/en-GB/products/UK000698/free-range-egg-mayo',
    carbs: '46.9',
  },
  {
    category: { url: '/en-GB/products/categories/sandwiches', category: 'Sandwiches' },
    item: 'Ham & Cheese',
    url: '/en-GB/products/UK006440/ham-and-cheese',
    carbs: '42.5',
  },
  {
    category: { url: '/en-GB/products/categories/sandwiches', category: 'Sandwiches' },
    item: "Kids' Cheese Sandwich",
    url: '/en-GB/products/UK004155/kids-cheese-sandwich',
    carbs: '39.8',
  },
  {
    category: { url: '/en-GB/products/categories/sandwiches', category: 'Sandwiches' },
    item: "Kids' Free-Range Egg Mayo Sandwich",
    url: '/en-GB/products/UK007694/kids-free-range-egg-mayo-sandwich',
    carbs: '44.4',
  },
  {
    category: { url: '/en-GB/products/categories/sandwiches', category: 'Sandwiches' },
    item: "Kids' Ham Sandwich",
    url: '/en-GB/products/UK004154/kids-ham-sandwich',
    carbs: '42.1',
  },
  {
    category: { url: '/en-GB/products/categories/sandwiches', category: 'Sandwiches' },
    item: 'Mature Cheddar & Pret Pickle',
    url: '/en-GB/products/UK001531/mature-cheddar-and-pret-pickle',
    carbs: '53',
  },
  {
    category: { url: '/en-GB/products/categories/sandwiches', category: 'Sandwiches' },
    item: 'Scottish Smoked Salmon',
    url: '/en-GB/products/UK000716/scottish-smoked-salmon',
    carbs: '39',
  },
  {
    category: { url: '/en-GB/products/categories/sandwiches', category: 'Sandwiches' },
    item: 'Smashed Avo Open Sandwich',
    url: '/en-GB/products/UK007180/smashed-avo-open-sandwich',
    carbs: '19.1',
  },
  {
    category: { url: '/en-GB/products/categories/sandwiches', category: 'Sandwiches' },
    item: 'Smoked Salmon & Soft Cheese Open Sandwich',
    url: '/en-GB/products/UK007663/smoked-salmon-and-soft-cheese-open-sandwich',
    carbs: '20.6',
  },
  {
    category: { url: '/en-GB/products/categories/sandwiches', category: 'Sandwiches' },
    item: 'Tuna & Cucumber',
    url: '/en-GB/products/UK006783/tuna-and-cucumber',
    carbs: '42.8',
  },
  {
    category: { url: '/en-GB/products/categories/breakfast', category: 'Breakfast' },
    item: 'Acai & Almond Butter Bowl',
    url: '/en-GB/products/UK006718/acai-and-almond-butter-bowl',
    carbs: '34.6',
  },
  {
    category: { url: '/en-GB/products/categories/breakfast', category: 'Breakfast' },
    item: 'Almond Croissant',
    url: '/en-GB/products/UK005667/almond-croissant',
    carbs: '40.3',
  },
  {
    category: { url: '/en-GB/products/categories/breakfast', category: 'Breakfast' },
    item: 'Bacon & Egg Roll',
    url: '/en-GB/products/UK008248/bacon-and-egg-roll',
    carbs: '40.8',
  },
  {
    category: { url: '/en-GB/products/categories/breakfast', category: 'Breakfast' },
    item: 'Bircher Muesli',
    url: '/en-GB/products/UK006210/bircher-muesli',
    carbs: '37.9',
  },
  {
    category: { url: '/en-GB/products/categories/breakfast', category: 'Breakfast' },
    item: 'Breakfast Egg & Avo',
    url: '/en-GB/products/UK007489/breakfast-egg-and-avo',
    carbs: '40.3',
  },
  {
    category: { url: '/en-GB/products/categories/breakfast', category: 'Breakfast' },
    item: 'Breakfast Egg & Bacon',
    url: '/en-GB/products/UK006825/breakfast-egg-and-bacon',
    carbs: '45.4',
  },
  {
    category: { url: '/en-GB/products/categories/breakfast', category: 'Breakfast' },
    item: 'Breakfast Egg & Tomatoes',
    url: '/en-GB/products/UK001044/breakfast-egg-and-tomatoes',
    carbs: '46.3',
  },
  {
    category: { url: '/en-GB/products/categories/breakfast', category: 'Breakfast' },
    item: 'Breakfast Salmon & Egg',
    url: '/en-GB/products/UK001341/breakfast-salmon-and-egg',
    carbs: '45.2',
  },
  {
    category: { url: '/en-GB/products/categories/breakfast', category: 'Breakfast' },
    item: 'Chocolate Croissant',
    url: '/en-GB/products/UK005671/chocolate-croissant',
    carbs: '33.4',
  },
  {
    category: { url: '/en-GB/products/categories/breakfast', category: 'Breakfast' },
    item: 'Cinnamon Danish',
    url: '/en-GB/products/UK006927/cinnamon-danish',
    carbs: '51.8',
  },
  {
    category: { url: '/en-GB/products/categories/breakfast', category: 'Breakfast' },
    item: 'Five Berry Bowl',
    url: '/en-GB/products/UK005773/five-berry-bowl',
    carbs: '47.8',
  },
  {
    category: { url: '/en-GB/products/categories/breakfast', category: 'Breakfast' },
    item: 'French Butter Croissant',
    url: '/en-GB/products/UK000765/french-butter-croissant',
    carbs: '27.6',
  },
  {
    category: { url: '/en-GB/products/categories/breakfast', category: 'Breakfast' },
    item: 'Fresh Fruit, Yoghurt & Granola Bowl',
    url: '/en-GB/products/UK007836/fresh-fruit-yoghurt-and-granola-bowl',
    carbs: '33.6',
  },
  {
    category: { url: '/en-GB/products/categories/breakfast', category: 'Breakfast' },
    item: 'Ham & Egg Breakfast Roll',
    url: '/en-GB/products/UK008250/ham-and-egg-breakfast-roll',
    carbs: '40.4',
  },
  {
    category: { url: '/en-GB/products/categories/breakfast', category: 'Breakfast' },
    item: 'Ham, Cheese, Tomato & Bacon Croissant',
    url: '/en-GB/products/UK004468/ham-cheese-tomato-and-bacon-croissant',
    carbs: '21.2',
  },
  {
    category: { url: '/en-GB/products/categories/breakfast', category: 'Breakfast' },
    item: 'Mango & Banana Sunshine Bowl',
    url: '/en-GB/products/UK007101/mango-and-banana-sunshine-bowl',
    carbs: '42',
  },
  {
    category: { url: '/en-GB/products/categories/breakfast', category: 'Breakfast' },
    item: 'Mozzarella & Tomato Croissant',
    url: '/en-GB/products/UK004469/mozzarella-and-tomato-croissant',
    carbs: '20.5',
  },
  {
    category: { url: '/en-GB/products/categories/breakfast', category: 'Breakfast' },
    item: 'Pain aux Raisins',
    url: '/en-GB/products/UK005705/pain-aux-raisins',
    carbs: '50',
  },
  {
    category: { url: '/en-GB/products/categories/breakfast', category: 'Breakfast' },
    item: 'Poached Egg & Beans Power Pot',
    url: '/en-GB/products/UK007807/poached-egg-and-beans-power-pot',
    carbs: '23.1',
  },
  {
    category: { url: '/en-GB/products/categories/breakfast', category: 'Breakfast' },
    item: 'Porridge Topping - Compote',
    url: '/en-GB/products/UK005569/porridge-topping-compote',
    carbs: '5.5',
  },
  {
    category: { url: '/en-GB/products/categories/breakfast', category: 'Breakfast' },
    item: 'Porridge Topping - Cranberry & Seeds',
    url: '/en-GB/products/UK005737/porridge-topping-cranberry-and-seeds',
    carbs: '14.4',
  },
  {
    category: { url: '/en-GB/products/categories/breakfast', category: 'Breakfast' },
    item: "Pret's Bacon Roll",
    url: '/en-GB/products/UK008251/prets-bacon-roll',
    carbs: '40.5',
  },
  {
    category: { url: '/en-GB/products/categories/breakfast', category: 'Breakfast' },
    item: "Pret's Proper Porridge",
    url: '/en-GB/products/UK004209/prets-proper-porridge',
    carbs: '23.7',
  },
  {
    category: { url: '/en-GB/products/categories/breakfast', category: 'Breakfast' },
    item: "Pret's Veggie Roll",
    url: '/en-GB/products/UK008249/prets-veggie-roll',
    carbs: '41.4',
  },
  {
    category: { url: '/en-GB/products/categories/breakfast', category: 'Breakfast' },
    item: 'Sausage & Egg Roll',
    url: '/en-GB/products/UK008247/sausage-and-egg-roll',
    carbs: '43.4',
  },
  {
    category: { url: '/en-GB/products/categories/breakfast', category: 'Breakfast' },
    item: 'Very Berry Croissant',
    url: '/en-GB/products/UK007692/very-berry-croissant',
    carbs: '41.7',
  },
  {
    category: { url: '/en-GB/products/categories/cold-drinks', category: 'Cold Drinks' },
    item: 'Apple Juice',
    url: '/en-GB/products/UK005781/apple-juice',
    carbs: '27',
  },
  {
    category: { url: '/en-GB/products/categories/cold-drinks', category: 'Cold Drinks' },
    item: 'Avo Smoothie',
    url: '/en-GB/products/UK007078/avo-smoothie',
    carbs: '39.2',
  },
  {
    category: { url: '/en-GB/products/categories/cold-drinks', category: 'Cold Drinks' },
    item: 'Berry Blast',
    url: '/en-GB/products/UK005643/berry-blast',
    carbs: '51.4',
  },
  {
    category: { url: '/en-GB/products/categories/cold-drinks', category: 'Cold Drinks' },
    item: 'Carrot Juice',
    url: '/en-GB/products/UK005784/carrot-juice',
    carbs: '12',
  },
  {
    category: { url: '/en-GB/products/categories/cold-drinks', category: 'Cold Drinks' },
    item: 'Chocolate Frappe',
    url: '/en-GB/products/UK005804/chocolate-frappe',
    carbs: '71.5',
  },
  {
    category: { url: '/en-GB/products/categories/cold-drinks', category: 'Cold Drinks' },
    item: 'Classic Frappe',
    url: '/en-GB/products/UK005078/classic-frappe',
    carbs: '40.5',
  },
  {
    category: { url: '/en-GB/products/categories/cold-drinks', category: 'Cold Drinks' },
    item: 'Coke Bottle Reg',
    url: '/en-GB/products/UK001022/coke-bottle-reg',
    carbs: '53',
  },
  {
    category: { url: '/en-GB/products/categories/cold-drinks', category: 'Cold Drinks' },
    item: 'Coke Can Diet',
    url: '/en-GB/products/UK000783/coke-can-diet',
    carbs: '0',
  },
  {
    category: { url: '/en-GB/products/categories/cold-drinks', category: 'Cold Drinks' },
    item: 'Coke Can Regular',
    url: '/en-GB/products/UK000823/coke-can-regular',
    carbs: '35',
  },
  {
    category: { url: '/en-GB/products/categories/cold-drinks', category: 'Cold Drinks' },
    item: 'Coke Can Zero',
    url: '/en-GB/products/UK006676/coke-can-zero',
    carbs: '0',
  },
  {
    category: { url: '/en-GB/products/categories/cold-drinks', category: 'Cold Drinks' },
    item: 'Coke Zero Bottle',
    url: '/en-GB/products/UK006710/coke-zero-bottle',
    carbs: '0',
  },
  {
    category: { url: '/en-GB/products/categories/cold-drinks', category: 'Cold Drinks' },
    item: 'Cranberry & Raspberry Pure Pret Still',
    url: '/en-GB/products/UK006363/cranberry-and-raspberry-pure-pret-still',
    carbs: '39.5',
  },
  {
    category: { url: '/en-GB/products/categories/cold-drinks', category: 'Cold Drinks' },
    item: 'Daily Greens',
    url: '/en-GB/products/UK007075/daily-greens',
    carbs: '32',
  },
  {
    category: { url: '/en-GB/products/categories/cold-drinks', category: 'Cold Drinks' },
    item: 'Diet Coke Bottle',
    url: '/en-GB/products/UK001286/diet-coke-bottle',
    carbs: '0',
  },
  {
    category: { url: '/en-GB/products/categories/cold-drinks', category: 'Cold Drinks' },
    item: 'Ginger Kombucha',
    url: '/en-GB/products/UK007681/ginger-kombucha',
    carbs: '10.8',
  },
  {
    category: { url: '/en-GB/products/categories/cold-drinks', category: 'Cold Drinks' },
    item: 'Ginger Shot',
    url: '/en-GB/products/UK005840/ginger-shot',
    carbs: '11.4',
  },
  {
    category: { url: '/en-GB/products/categories/cold-drinks', category: 'Cold Drinks' },
    item: 'Green Tea & Peach Pure Pret Still',
    url: '/en-GB/products/UK005416/green-tea-and-peach-pure-pret-still',
    carbs: '21',
  },
  {
    category: { url: '/en-GB/products/categories/cold-drinks', category: 'Cold Drinks' },
    item: 'Hot Shot',
    url: '/en-GB/products/UK006608/hot-shot',
    carbs: '5.2',
  },
  {
    category: { url: '/en-GB/products/categories/cold-drinks', category: 'Cold Drinks' },
    item: "Kid's Cold  Milk",
    url: '/en-GB/products/UK004832/kids-cold-milk',
    carbs: '9',
  },
  {
    category: { url: '/en-GB/products/categories/cold-drinks', category: 'Cold Drinks' },
    item: 'Large Orange Juice',
    url: '/en-GB/products/UK005782/large-orange-juice',
    carbs: '38.4',
  },
  {
    category: { url: '/en-GB/products/categories/cold-drinks', category: 'Cold Drinks' },
    item: 'Lemon & Ginger Pure Pret Still',
    url: '/en-GB/products/UK005413/lemon-and-ginger-pure-pret-still',
    carbs: '34.9',
  },
  {
    category: { url: '/en-GB/products/categories/cold-drinks', category: 'Cold Drinks' },
    item: 'Mango & Pineapple Smoothie',
    url: '/en-GB/products/UK005031/mango-and-pineapple-smoothie',
    carbs: '49',
  },
  {
    category: { url: '/en-GB/products/categories/cold-drinks', category: 'Cold Drinks' },
    item: 'Mango Smoothie',
    url: '/en-GB/products/UK005786/mango-smoothie',
    carbs: '31.8',
  },
  {
    category: { url: '/en-GB/products/categories/cold-drinks', category: 'Cold Drinks' },
    item: 'Orange & Passion Fruit Pure Pret Still',
    url: '/en-GB/products/UK006364/orange-and-passion-fruit-pure-pret-still',
    carbs: '30',
  },
  {
    category: { url: '/en-GB/products/categories/cold-drinks', category: 'Cold Drinks' },
    item: 'Orange Juice',
    url: '/en-GB/products/UK005783/orange-juice',
    carbs: '22.5',
  },
  {
    category: { url: '/en-GB/products/categories/cold-drinks', category: 'Cold Drinks' },
    item: 'Pure Pret Rhubarb Lemonade',
    url: '/en-GB/products/UK007676/pure-pret-rhubarb-lemonade',
    carbs: '26.7',
  },
  {
    category: { url: '/en-GB/products/categories/cold-drinks', category: 'Cold Drinks' },
    item: 'Pure Pret Sparkling Apple Fizz',
    url: '/en-GB/products/UK007673/pure-pret-sparkling-apple-fizz',
    carbs: '26.1',
  },
  {
    category: { url: '/en-GB/products/categories/cold-drinks', category: 'Cold Drinks' },
    item: 'Pure Pret Sparkling Ginger Beer',
    url: '/en-GB/products/UK007674/pure-pret-sparkling-ginger-beer',
    carbs: '29.7',
  },
  {
    category: { url: '/en-GB/products/categories/cold-drinks', category: 'Cold Drinks' },
    item: 'Pure Pret Sparkling Grape & Elderflower',
    url: '/en-GB/products/UK007675/pure-pret-sparkling-grape-and-elderflower',
    carbs: '24.4',
  },
  {
    category: { url: '/en-GB/products/categories/cold-drinks', category: 'Cold Drinks' },
    item: 'Pure Pret Sparkling Green Tea Yoga Bunny',
    url: '/en-GB/products/UK007677/pure-pret-sparkling-green-tea-yoga-bunny',
    carbs: '27.1',
  },
  {
    category: { url: '/en-GB/products/categories/cold-drinks', category: 'Cold Drinks' },
    item: 'Still Water 500ml',
    url: '/en-GB/products/UK000780/still-water-500ml',
    carbs: '0',
  },
  {
    category: { url: '/en-GB/products/categories/cold-drinks', category: 'Cold Drinks' },
    item: 'Still Water 750ml',
    url: '/en-GB/products/UK003347/still-water-750ml',
    carbs: '0',
  },
  {
    category: { url: '/en-GB/products/categories/cold-drinks', category: 'Cold Drinks' },
    item: 'Strawberry & Banana Smoothie',
    url: '/en-GB/products/UK005996/strawberry-and-banana-smoothie',
    carbs: '47.8',
  },
  {
    category: { url: '/en-GB/products/categories/cold-drinks', category: 'Cold Drinks' },
    item: 'Vitamin Volcano',
    url: '/en-GB/products/UK005788/vitamin-volcano',
    carbs: '30.5',
  },
  {
    category: { url: '/en-GB/products/categories/prets-hot', category: "Pret's Hot" },
    item: 'Brie & Bacon Focaccia',
    url: '/en-GB/products/UK007670/brie-and-bacon-focaccia',
    carbs: '51.8',
  },
  {
    category: { url: '/en-GB/products/categories/prets-hot', category: "Pret's Hot" },
    item: 'Butternut Squash & Cauli Gratin',
    url: '/en-GB/products/UK007177/butternut-squash-and-cauli-gratin',
    carbs: '24.3',
  },
  {
    category: { url: '/en-GB/products/categories/prets-hot', category: "Pret's Hot" },
    item: 'Classic Cheese Toastie',
    url: '/en-GB/products/UK007640/classic-cheese-toastie',
    carbs: '50.2',
  },
  {
    category: { url: '/en-GB/products/categories/prets-hot', category: "Pret's Hot" },
    item: 'Falafel & Halloumi Hot Wrap',
    url: '/en-GB/products/UK006060/falafel-and-halloumi-hot-wrap',
    carbs: '59.2',
  },
  {
    category: { url: '/en-GB/products/categories/prets-hot', category: "Pret's Hot" },
    item: 'Firecracker Chicken Toasted Focaccia',
    url: '/en-GB/products/UK008129/firecracker-chicken-toasted-focaccia',
    carbs: '54.2',
  },
  {
    category: { url: '/en-GB/products/categories/prets-hot', category: "Pret's Hot" },
    item: 'Ham, Cheese & Mustard Toastie',
    url: '/en-GB/products/UK004109/ham-cheese-and-mustard-toastie',
    carbs: '46.8',
  },
  {
    category: { url: '/en-GB/products/categories/prets-hot', category: "Pret's Hot" },
    item: 'Macaroni Cheese Kale & Cauli',
    url: '/en-GB/products/UK005764/macaroni-cheese-kale-and-cauli',
    carbs: '49.7',
  },
  {
    category: { url: '/en-GB/products/categories/prets-hot', category: "Pret's Hot" },
    item: 'Macaroni Cheese Prosciutto',
    url: '/en-GB/products/UK005763/macaroni-cheese-prosciutto',
    carbs: '49.9',
  },
  {
    category: { url: '/en-GB/products/categories/prets-hot', category: "Pret's Hot" },
    item: 'Mozzarella, Pesto & Roasted Tomatoes Focaccia',
    url: '/en-GB/products/UK007637/mozzarella-pesto-and-roasted-tomatoes-focaccia',
    carbs: '48',
  },
  {
    category: { url: '/en-GB/products/categories/prets-hot', category: "Pret's Hot" },
    item: "Pret's Fish Pie Macaroni Cheese",
    url: '/en-GB/products/UK007241/prets-fish-pie-macaroni-cheese',
    carbs: '55.5',
  },
  {
    category: { url: '/en-GB/products/categories/prets-hot', category: "Pret's Hot" },
    item: "Pret's Lasagne Macaroni Cheese",
    url: '/en-GB/products/UK007240/prets-lasagne-macaroni-cheese',
    carbs: '34.4',
  },
  {
    category: { url: '/en-GB/products/categories/prets-hot', category: "Pret's Hot" },
    item: "Pret's Sausage Roll",
    url: '/en-GB/products/UK008246/prets-sausage-roll',
    carbs: '25.4',
  },
  {
    category: { url: '/en-GB/products/categories/prets-hot', category: "Pret's Hot" },
    item: 'Spicy Chicken Hot Wrap',
    url: '/en-GB/products/UK007149/spicy-chicken-hot-wrap',
    carbs: '45',
  },
  {
    category: { url: '/en-GB/products/categories/prets-hot', category: "Pret's Hot" },
    item: 'Squash, Soft Cheese & Feta Omelette',
    url: '/en-GB/products/UK007627/squash-soft-cheese-and-feta-omelette',
    carbs: '5.3',
  },
  {
    category: { url: '/en-GB/products/categories/prets-hot', category: "Pret's Hot" },
    item: 'Swedish Meatball Hot Wrap',
    url: '/en-GB/products/UK006491/swedish-meatball-hot-wrap',
    carbs: '44.1',
  },
  {
    category: { url: '/en-GB/products/categories/prets-hot', category: "Pret's Hot" },
    item: 'Tuna Melt Toastie',
    url: '/en-GB/products/UK006484/tuna-melt-toastie',
    carbs: '47.6',
  },
  {
    category: { url: '/en-GB/products/categories/prets-hot', category: "Pret's Hot" },
    item: 'Vegan Ragu & Red Pepper Hot Wrap',
    url: '/en-GB/products/UK006965/vegan-ragu-and-red-pepper-hot-wrap',
    carbs: '62',
  },
  {
    category: {
      url: '/en-GB/products/categories/tea-and-hot-drinks',
      category: 'Tea & Hot Drinks',
    },
    item: 'Babyccino',
    url: '/en-GB/products/UK003567/babyccino',
    carbs: '1.4',
  },
  {
    category: {
      url: '/en-GB/products/categories/tea-and-hot-drinks',
      category: 'Tea & Hot Drinks',
    },
    item: 'Breakfast Tea with Semi-skimmed Milk',
    url: '/en-GB/products/UK003463/breakfast-tea-with-semi-skimmed-milk',
    carbs: '1.4',
  },
  {
    category: {
      url: '/en-GB/products/categories/tea-and-hot-drinks',
      category: 'Tea & Hot Drinks',
    },
    item: 'Earl Grey Tea with Semi-skimmed Milk',
    url: '/en-GB/products/UK003464/earl-grey-tea-with-semi-skimmed-milk',
    carbs: '1.4',
  },
  {
    category: {
      url: '/en-GB/products/categories/tea-and-hot-drinks',
      category: 'Tea & Hot Drinks',
    },
    item: 'Hot Chocolate with Semi-skimmed Milk',
    url: '/en-GB/products/UK004550/hot-chocolate-with-semi-skimmed-milk',
    carbs: '37.5',
  },
  {
    category: {
      url: '/en-GB/products/categories/tea-and-hot-drinks',
      category: 'Tea & Hot Drinks',
    },
    item: 'Matcha Latte',
    url: '/en-GB/products/UK006758/matcha-latte',
    carbs: '42.4',
  },
  {
    category: {
      url: '/en-GB/products/categories/tea-and-hot-drinks',
      category: 'Tea & Hot Drinks',
    },
    item: 'Organic Chai Latte',
    url: '/en-GB/products/UK006105/organic-chai-latte',
    carbs: '35.5',
  },
  {
    category: {
      url: '/en-GB/products/categories/tea-and-hot-drinks',
      category: 'Tea & Hot Drinks',
    },
    item: 'Peppermint Peace',
    url: '/en-GB/products/UK003465/peppermint-peace',
    carbs: '0',
  },
  {
    category: {
      url: '/en-GB/products/categories/tea-and-hot-drinks',
      category: 'Tea & Hot Drinks',
    },
    item: 'Rice-Coconut Hot Chocolate',
    url: '/en-GB/products/UK006579/rice-coconut-hot-chocolate',
    carbs: '57.1',
  },
  {
    category: {
      url: '/en-GB/products/categories/tea-and-hot-drinks',
      category: 'Tea & Hot Drinks',
    },
    item: 'Rice-Coconut Milk Alternative',
    url: '/en-GB/products/UK006470/rice-coconut-milk-alternative',
    carbs: '31.3',
  },
  {
    category: {
      url: '/en-GB/products/categories/tea-and-hot-drinks',
      category: 'Tea & Hot Drinks',
    },
    item: 'Soya Hot Chocolate',
    url: '/en-GB/products/UK006902/soya-hot-chocolate',
    carbs: '32.4',
  },
  {
    category: {
      url: '/en-GB/products/categories/tea-and-hot-drinks',
      category: 'Tea & Hot Drinks',
    },
    item: 'Tropical Green Tea',
    url: '/en-GB/products/UK003466/tropical-green-tea',
    carbs: '0',
  },
  {
    category: {
      url: '/en-GB/products/categories/tea-and-hot-drinks',
      category: 'Tea & Hot Drinks',
    },
    item: 'Turmeric Latte',
    url: '/en-GB/products/UK007099/turmeric-latte',
    carbs: '39.4',
  },
  {
    category: { url: '/en-GB/products/categories/fruit', category: 'Fruit' },
    item: 'Apple',
    url: '/en-GB/products/UK001528/apple',
    carbs: '18.9',
  },
  {
    category: { url: '/en-GB/products/categories/fruit', category: 'Fruit' },
    item: 'Banana',
    url: '/en-GB/products/UK000831/banana',
    carbs: '13.9',
  },
  {
    category: { url: '/en-GB/products/categories/fruit', category: 'Fruit' },
    item: 'Mango & Lime',
    url: '/en-GB/products/UK005229/mango-and-lime',
    carbs: '19',
  },
  {
    category: { url: '/en-GB/products/categories/fruit', category: 'Fruit' },
    item: "Pret's Fruit Salad",
    url: '/en-GB/products/UK005231/prets-fruit-salad',
    carbs: '22',
  },
  {
    category: { url: '/en-GB/products/categories/fruit', category: 'Fruit' },
    item: 'SuperFruit Salad',
    url: '/en-GB/products/UK006091/superfruit-salad',
    carbs: '22',
  },
  {
    category: { url: '/en-GB/products/categories/heat-at-home', category: 'Heat at Home' },
    item: "Pret's Proper Porridge",
    url: '/en-GB/products/UK008218/prets-proper-porridge',
    carbs: '23.7',
  },
  {
    category: { url: '/en-GB/products/categories/heat-at-home', category: 'Heat at Home' },
    item: 'Soup - Chicken & Butternut Risotto ',
    url: '/en-GB/products/UK008190/soup-chicken-and-butternut-risotto',
    carbs: '30.8',
  },
  {
    category: { url: '/en-GB/products/categories/heat-at-home', category: 'Heat at Home' },
    item: 'Soup - Pea & Mint',
    url: '/en-GB/products/UK008188/soup-pea-and-mint',
    carbs: '22.4',
  },
  {
    category: { url: '/en-GB/products/categories/heat-at-home', category: 'Heat at Home' },
    item: "Soup - Pret's Mushroom Risotto",
    url: '/en-GB/products/UK008189/soup-prets-mushroom-risotto',
    carbs: '8.8',
  },
  {
    category: {
      url: '/en-GB/products/categories/pret-coffee-at-home',
      category: 'Pret Coffee at Home',
    },
    item: "Pret's Organic Classic Blend Ground Coffee 500g",
    url: '/en-GB/products/UK008136/prets-organic-classic-blend-ground-coffee-500g',
  },
  {
    category: {
      url: '/en-GB/products/categories/pret-coffee-at-home',
      category: 'Pret Coffee at Home',
    },
    item: "Pret's Organic Espresso Beans 1kg",
    url: '/en-GB/products/UK008137/prets-organic-espresso-beans-1kg',
  },
  {
    category: {
      url: '/en-GB/products/categories/pret-coffee-at-home',
      category: 'Pret Coffee at Home',
    },
    item: "Pret's Organic Single Origin Peruvian Ground Coffee 500g",
    url: '/en-GB/products/UK008135/prets-organic-single-origin-peruvian-ground-coffee-500g',
  },
];

export default data;
